module.exports = __webpack_public_path__ + "static/media/ctxc.27d95af6.svg";